import React from 'react'
import _ from 'lodash'
import {Grid, Row} from 'react-flexbox-grid'
import ReactSafeHtml from 'react-safe-html'

import {Loading} from '../ui'
import {req} from '../nanoajax.js'

export const DOCURL = 'https://docs.tiny-mesh.com/tm-docs/'

// resolveURL, source: https://github.com/lydell/resolve-url/
// Copyright 2014 Simon Lydell
// X11 (“MIT”) Licensed. (See LICENSE.)
const aElem = document.createElement('a')
const baseElem = document.createElement('base')

const head = document.getElementsByTagName('head')[0]

head.insertBefore(baseElem, head.firstChild)

function resolveUrl(from, to) {
   let target = to,
      oldBase = baseElem.href

   if (!from || !to) {
      throw new Error('resolveUrl requires two arguments')
   }

   if ('/' === target[0]) {
      return to
   } else if ('./' !== target.slice(0, 2)) {
      target = './' + target
   }

   baseElem.href = from
   aElem.href = target
   let ret = aElem.pathname

   baseElem.href = oldBase

   return ret
}

export class Docs extends React.Component {
   static get propTypes() {
      return {
         params: React.PropTypes.object.isRequired,
         routes: React.PropTypes.array.isRequired
      }
   }

   constructor(props) {
      super()

      let root = _.reduce(props.routes, (acc, route) => acc + route.path, '').replace(/\/\*$/, '')

      this.state = {
         root:    root,
         url:     null,
         body:    null,
         loading: false
      }

      this._locked = null

      const attrs = {
         class: css => ['className', css]
      }

      this._components = ReactSafeHtml.components.makeElements({})

      const allowed = [
         'div',
         'span',
         'p',
         'i',
         'em',
         'b',
         'small',
         'sup',
         'sub',
         'strike',
         ['a', 'title', 'href'],
         'strong',
         'u',
         'address',
         'img',
         'ol',
         'ul',
         'li',
         'dl',
         'dd',
         'dt',
         'h1',
         'h2',
         'h3',
         'h4',
         'h5',
         'h6',
         'title'
      ]

      const funcs = {
         a: {
            href: target => {
               let source = this.state.url

               // not realtive to this url
               if (DOCURL !== source.slice(0, DOCURL.length)) {
                  return target
               }

               if (!source.match(/.html$/)) {
                  source = source + '/'
               }

               return '#' + this.state.root + resolveUrl(source.slice(DOCURL.length - 1), target)
            }
         }
      }

      _.each(allowed, elem => {
         let tag = _.isArray(elem) ? elem[0] : elem,
            theseattrs = _.clone(attrs)

         if (_.isArray(elem)) {
            _.each(elem.slice(1), attr => {
               let fun = _.get(funcs, [tag, attr])

               theseattrs[attr] = fun ? result => [attr, fun(result)] : result => [attr, result]
            })
         }

         this._components[tag] = ReactSafeHtml.components.createSimpleElement(tag, theseattrs)
      })
   }

   asyncLoadPage(url) {
      const resource = DOCURL + url
      const headers = {Accept: 'text/html;*/*'}

      this.setState({loading: true})
      this._locked = req
         .get(resource, null, headers)
         .then(([resp]) => {
            this._locked = false

            let ret = resp.match(/<body>((?:.|[\r\n])*)<\/body>/)

            this.setState({
               url:     resource,
               body:    ret ? ret[1] : resp,
               loading: false
            })

            return ret ? ret[1] : resp
         })
         .catch(() => this.setState({loading: false, body: null}))
   }

   componentDidMount() {
      let url = this.props.params.splat || ''

      this.asyncLoadPage(url)
   }

   componentWillReceiveProps(nextProps) {
      let url = nextProps.params.splat || ''

      if (this.state.url !== url) {
         this.setState({url}, () => this.asyncLoadPage(url))
      }
   }

   render() {
      const {body, loading} = this.state

      return (
         <Loading loading={loading} overlay={true}>
            <Grid>
               <Row className="embedded-docs">
                  <ReactSafeHtml html={body} components={this._components} />
               </Row>
            </Grid>
         </Loading>
      )
   }
}



// WEBPACK FOOTER //
// lib/pages/Docs.jsx